import { customerEmailCopies } from '@/common/components/SendEmailDrawer/constants'

export const emailDestinations = {
  customer: 'customer',
  carrier: 'carrier',
}

export const copiesByEmailDestination = {
  [emailDestinations.customer]: customerEmailCopies,
  [emailDestinations.carrier]: {
    title: 'Contactar con el transportista',
    to: 'Email del transportista',
    replyTo: 'Email de respuesta (Reply-to)',
  },
}
